import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_2 = { class: "gfu-grid__cell gfu-1of1 _mt-4" }
const _hoisted_3 = { class: "gfu-heading gfu-heading--top-divider" }
const _hoisted_4 = { class: "gfu-grid__cell gfu-1of1 _mt-4" }
const _hoisted_5 = { class: "gfu-heading gfu-heading--top-divider" }
const _hoisted_6 = { class: "gfu-grid gfu-grid--gutter-columns _mt-4" }
const _hoisted_7 = {
  class: "gfu-grid__cell gfu-1of1",
  "data-qa": "shipping-method-section"
}
const _hoisted_8 = { class: "gfu-heading gfu-heading--top-divider" }
const _hoisted_9 = ["data-qa"]
const _hoisted_10 = ["data-qa"]
const _hoisted_11 = { class: "gfu-grid__cell gfu-1of1 _mt-3" }
const _hoisted_12 = { class: "gfu-1of1 _flexwrap-reverse _jc-sb _ai-c" }
const _hoisted_13 = { class: "gfu-1of1 gfu-1of2--m gfu-1of3--l" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "gfu-1of1 gfu-1of2--m gfu-1of3--l" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_notificator = _resolveComponent("notificator")
  const _component_address_data_form = _resolveComponent("address-data-form")
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_field = _resolveComponent("field")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_notificator, {
      ref: "notify",
      singular: true
    }, null, 512 /* NEED_PATCH */),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString($options.formTitle), 1 /* TEXT */),
        (_ctx.isLocationsLoaded)
          ? (_openBlock(), _createBlock(_component_address_data_form, {
              key: "shippingAddressDataForm",
              ref: "shippingAddressDataForm",
              modelValue: $options.shippingAddressData,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.shippingAddressData) = $event)),
              "location-specific-field-rules": _ctx.locationSpecificFieldRules,
              "phone-number-required": $props.phoneNumberRequired,
              "show-address-line2": $props.showAddressLine2,
              "show-address-line3": $props.showAddressLine3,
              "read-only": $props.disableAddressChange,
              "show-notes": true,
              "show-vat-id": true,
              "is-registered-vat-payer-checkbox-visible": $options.isRegisteredVatPayerCheckboxVisible,
              "project-locations": _ctx.projectLocations,
              "allow-location-change": $options.shouldAllowShippingLocationChange,
              "allow-sub-location-change": $options.shouldAllowShippingSubLocationChange,
              onLocationChange: $options.onShippingLocationChange,
              onSublocationChange: $options.onShippingSublocationChange,
              "data-qa": "begin-order-form:ShippingAddress"
            }, null, 8 /* PROPS */, ["modelValue", "location-specific-field-rules", "phone-number-required", "show-address-line2", "show-address-line3", "read-only", "is-registered-vat-payer-checkbox-visible", "project-locations", "allow-location-change", "allow-sub-location-change", "onLocationChange", "onSublocationChange"]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_checkbox_field, {
          modelValue: $options.myBillingInformationIsDifferentFromShipping,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($options.myBillingInformationIsDifferentFromShipping) = $event)),
          "display-name": _ctx.Resources.Checkout.DifferentBillingAddressLabel,
          condensed: true,
          disabled: $options.isBillingInformationDifferentCheckboxDisabled,
          class: "_mt-3",
          "data-qa": "begin-order-form:differentBilling"
        }, null, 8 /* PROPS */, ["modelValue", "display-name", "disabled"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.Resources.Checkout.BillingAddressTitle), 1 /* TEXT */),
        (_ctx.isLocationsLoaded)
          ? (_openBlock(), _createBlock(_component_address_data_form, {
              ref: "customerAddressDataForm",
              key: "customerAddressDataForm",
              modelValue: $options.customerAddressData,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($options.customerAddressData) = $event)),
              "phone-number-required": $props.phoneNumberRequired,
              "show-vat-id": false,
              "project-locations": _ctx.projectLocations,
              "validate-vat-id": $options.hasReverseVatEnabled && _ctx.model.vatInvoice === true,
              "show-address-line2": $props.showAddressLine2,
              "show-address-line3": $props.showAddressLine3,
              "read-only": $props.disableAddressChange || $props.isOrderAmended || !_ctx.model.specificCustomerAddress,
              "show-notes": true,
              "allow-location-change": $options.shouldAllowBillingAddressLocationChange,
              "allow-sub-location-change": $options.shouldAllowBillingAddressLocationChange,
              "data-qa": "begin-order-form:BillingAddress"
            }, null, 8 /* PROPS */, ["modelValue", "phone-number-required", "project-locations", "validate-vat-id", "show-address-line2", "show-address-line3", "read-only", "allow-location-change", "allow-sub-location-change"]))
          : _createCommentVNode("v-if", true)
      ], 512 /* NEED_PATCH */), [
        [_vShow, $options.myBillingInformationIsDifferentFromShipping]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("fieldset", null, [
          _createElementVNode("h2", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.ShippingMethodSectionTitle), 1 /* TEXT */),
            _cache[5] || (_cache[5] = _createElementVNode("em", null, "*", -1 /* CACHED */))
          ]),
          _createVNode(_component_field, {
            class: "_mt-0",
            "base-class": "",
            name: "model.shippingModelID",
            "show-label": false
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shippingModels, (shippingModel) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `shipping-method-${shippingModel.shippingModelID}`,
                  "data-qa": 'begin-order-form-shipping-method:'+ shippingModel.shippingModelID
                }, [
                  _createVNode(_component_checkbox_field, {
                    modelValue: _ctx.model.shippingModelID,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.model.shippingModelID) = $event)),
                    "checked-value": shippingModel.shippingModelID,
                    condensed: true,
                    type: "radio"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(shippingModel.name) + " ", 1 /* TEXT */),
                      (shippingModel.shippingCostDifferenceConverted !== null)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            "data-qa": `shipping-cost:${shippingModel.shippingCostDifferenceConverted}`
                          }, " (" + _toDisplayString($options.getShippingInfo(shippingModel)) + ") ", 9 /* TEXT, PROPS */, _hoisted_10))
                        : _createCommentVNode("v-if", true),
                      (shippingModel.description)
                        ? (_openBlock(), _createBlock(_component_tooltip, {
                            key: 1,
                            text: shippingModel.description
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("em", null, [
                                _createVNode(_component_base_icon, { name: "info" })
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["text"]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "checked-value"])
                ], 8 /* PROPS */, _hoisted_9))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("a", {
                href: $props.projectUrl,
                class: "_tc--accent _flex _ai-c",
                onClick: _cache[4] || (_cache[4] = (...args) => ($options.onGoBack && $options.onGoBack(...args)))
              }, [
                _createVNode(_component_base_icon, {
                  name: "chevron-left _mr-1",
                  "data-qa": "begin-order-button:Back"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.Resources.Common.GoBackButton), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_base_button, {
                type: "button",
                class: "gfu-btn gfu-btn--accent gfu-btn--block _mb-1",
                disabled: !$options.canSubmit,
                onClick: $options.onSubmit,
                "data-qa": "begin-order-form-button:Continue"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.Common.ModalContinueButton), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled", "onClick"])
            ])
          ])
        ])
      ])
    ])
  ]))
}